import { Box, Flex } from "@chakra-ui/react";
import React from "react";

const AddButton = ({ text, onClick, icon, name }) => {
  return (
    <Flex
      backgroundColor={"blue.600"}
      w={"fit-content"}
      gap={2}
      borderRadius={"15px"}
      p={["3px 5px","5px 15px"]}
      justifyContent={"center"}
      alignItems={"center"}
      cursor={"pointer"}
      _hover={{backgroundColor:"blue.700"}}
      transition="background-color 0.3s ease"
      onClick={onClick}
    >
      <Flex
        borderRadius={"50%"}
        backgroundColor={"white"}
        w={["20px", "35px"]}
        h={["20px", "35px"]}
        justifyContent={"center"}
        alignItems={"center"}
        // p={2}
      >
        {icon}
      </Flex>
      <Box w={["4rem","10rem"]}>
        <Box color={"white"} fontSize={["small",""]}>{name}</Box>
      </Box>
    </Flex>
  );
};

export default AddButton;
